export type CaptainMessageType =
  | 'welcome'
  | 'placed'
  | 'confirmed'
  | 'preparing'
  | 'ready'
  | 'complete'
  | 'cancelled'
  | 'wait_time'
  | 'table_ready'
  | 'nudge'
  | 'item_status'
  | 'assistance'
  | 'system';

export interface CaptainMessage {
  id: string;
  type: CaptainMessageType;
  title?: string;
  text: string;
  time: string;
  eta?: string;
  animate?: boolean;
}

export type CaptainEventType =
  | 'order.status.changed'
  | 'order.placed'
  | 'order.wait_time.updated'
  | 'table.assigned'
  | 'page.entered'
  | 'captain.message'
  | 'captain.speak';

export interface CaptainEvent {
  type: CaptainEventType;
  source: 'comet' | 'poll' | 'dom' | 'user' | 'system';
  payload: Record<string, unknown>;
  timestamp: number;
}

export type CaptainEventListener = (event: CaptainEvent) => void;

export interface OngoingOrderSnapshot {
  orderId: number;
  orderStatus: string;
  orderType: number;
  orderCode?: string;
  tableNumber?: number;
  spaceNoun?: string;
  waitTimeMinutes?: number;
  items: Array<{ name: string; quantity: number }>;
}

export interface CaptainAssistanceRequest {
  service: string;
  label: string;
  icon: string;
}

export const QUICK_ASSISTANCE_REQUESTS: CaptainAssistanceRequest[] = [
  { service: 'MINERAL_WATER', label: 'Mineral Water', icon: 'fa-tint' },
  { service: 'NORMAL_WATER', label: 'Normal Water', icon: 'fa-glass' },
  { service: 'SALT_PEPPER', label: 'Salt & Pepper', icon: 'fa-plus-circle' },
  { service: 'CUTLERY', label: 'Cutlery', icon: 'fa-cutlery' },
  { service: 'NAPKINS', label: 'Napkins', icon: 'fa-file-o' },
  { service: 'FINGER_BOWL', label: 'Finger Bowl', icon: 'fa-hand-paper-o' },
  { service: 'BILL_INVOICE', label: 'Bill / Invoice', icon: 'fa-file-text-o' },
  { service: 'TABLE_CLEANING', label: 'Table Cleaning', icon: 'fa-eraser' },
];

export const DINE_IN_ORDER_TYPE = 1;

/** Statuses where quick assistance (water, bill, call captain) is available */
export const ASSISTANCE_ELIGIBLE_STATUSES = [
  'ORDER_PLACED',
  'ORDER_CONFIRMED',
  'ORDER_MODIFIED',
  'ORDER_PREPARING',
  'ORDER_PREPARED',
  'ORDER_SERVED',
] as const;

export function isAssistanceEligibleStatus(status: string): boolean {
  return (ASSISTANCE_ELIGIBLE_STATUSES as readonly string[]).includes(status);
}
